import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { settingsApi } from '@/api/endpoints.js'

/**
 * Public site settings — name, currency, feature toggles.
 *
 * Fetched once at boot. Everything here is safe for an anonymous visitor to
 * see; the full settings object is admin-only and lives in its own view.
 */
export const useSettingsStore = defineStore('settings', () => {
  const settings = ref({
    siteName: 'PresenceRise',
    currency: 'USD',
    currencySymbol: '$',
    registrationEnabled: true,
    maintenanceMode: false,
    maintenanceMessage: null,
    minimumDeposit: '5.0000',
    // Not published — see serializePublicSettings on the API side.
    termsUrl: '/terms',
    privacyUrl: '/privacy',
  })
  const isLoaded = ref(false)

  const siteName = computed(() => settings.value.siteName)
  const currency = computed(() => settings.value.currency)
  const currencySymbol = computed(() => settings.value.currencySymbol)
  const isMaintenance = computed(() => settings.value.maintenanceMode)

  async function load() {
    try {
      const { data } = await settingsApi.public()
      settings.value = { ...settings.value, ...data }
      // The tab title should say who this is, not "Vite App".
      if (data.siteName) document.title = data.siteName
    } catch {
      // Falling back to the defaults above is better than blocking the app.
    } finally {
      isLoaded.value = true
    }
  }

  return { settings, isLoaded, siteName, currency, currencySymbol, isMaintenance, load }
})
